import { Button } from '../../components/ui';
import BotonOpcion from './BotonOpcion';
import './Buscar.css';

const IconPersona = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
);
const IconLista = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 7h18M3 12h18M3 17h18"/></svg>
);

export default function PasoTipo({ onElegir, onCancelar }) {
  return (
    <section aria-labelledby="t1">
      <div className="buscar-center">
        <h2 id="t1">¿Cómo querés buscar?</h2>
        <p className="buscar-muted">Elegí una opción para continuar.</p>
      </div>

      <div className="buscar-choices">
        <BotonOpcion
          icono={<IconPersona />}
          titulo="Búsqueda por nombre"
          descripcion="Buscá a un profesional escribiendo su nombre."
          onClick={() => onElegir('nombre')}
        />
        <BotonOpcion
          icono={<IconLista />}
          titulo="Búsqueda por servicio"
          descripcion="Mirá todos los servicios disponibles y elegí el que necesitás."
          onClick={() => onElegir('servicio')}
        />
      </div>

      <div className="buscar-actions">
        <Button variant="ghost" to="/">← Cancelar</Button>
        <span className="buscar-muted" style={{ alignSelf: 'center', fontSize: '.9rem' }}>Paso 1 de 3</span>
      </div>
    </section>
  );
}